import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountFormatter'
})
export class AmountPipe implements PipeTransform {
  transform(value: number): string {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + 'M+';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'k+';
    } else {
      return value.toString();
    }
  }
}
